export enum LabourWorkload {
  TotalTime = 1,
  PerCase = 2,
}
